const fetchReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_INIT":
      return {
        ...state,
        loading: true,
        error: false
      }
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload
      }
    case "FETCH_FAILURE":
      return {
        ...state,
        loading: false,
        error: true
      }
    default:
      throw new Error()
  }
}

export default fetchReducer
